export const sortOptions = [
  {
    value: "title",
    title: "Title",
  },
  {
    value: "body",
    title: "Body",
  },
];
